export var DocumentType;
(function (DocumentType) {
    DocumentType["MACADDRESS"] = "MACADDRESS";
    DocumentType["OPENNETWORK"] = "OPENNETWORK";
    DocumentType["OPENGLPUBBLICIP"] = "OPENGLPUBBLICIP";
    DocumentType["OPENDESTINATIONPUBBLICIP"] = "OPENDESTINATIONPUBBLICIP";
})(DocumentType || (DocumentType = {}));
